import React from 'react';

import { WarningMessage } from '@eika/attention-message';
import { ButtonWithSpinner } from '@eika/button-with-spinner';
import { IconTypes } from '@eika/icon';

import { useConfig } from '../../../../defaultConfig';
import { usePaymentAccountContext } from '../../../../hooks/useAccountState';
import useTranslation from '../../../../hooks/useTranslation';
import requireMultipleApprovers from '../../../../utils/boolean/requireMultipleApprovers';
import { PaymentState } from '../../../transaction/Payment/form/state';
import FormApproveSectionWithOutbox from './FormApproveSectionWithOutbox';
import PaymentButtonText from './PaymentButtonText';

type FormApproveSectionProps = {
    state: PaymentState;
    paymentOperationPending: boolean;
    isPostingOutboxItem: boolean;
    onAddPaymentToApprovalOutbox(event: React.MouseEvent<HTMLButtonElement>): void;
    isApproveDisabled: boolean;
};

const FormApproveSection: React.FC<FormApproveSectionProps> = ({
    state,
    paymentOperationPending,
    onAddPaymentToApprovalOutbox,
    isPostingOutboxItem,
    isApproveDisabled,
}) => {
    const { featureToggles } = useConfig();
    const translated = useTranslation();
    const { targetFromAccount } = usePaymentAccountContext();
    const multipleApprovers = requireMultipleApprovers(targetFromAccount);

    if (featureToggles.enableBulkPayment && !state.immediate)
        return (
            <FormApproveSectionWithOutbox
                isApproveDisabled={isApproveDisabled}
                onAddPaymentToApprovalOutbox={onAddPaymentToApprovalOutbox}
                paymentOperationPending={paymentOperationPending}
                isPostingOutboxItem={isPostingOutboxItem}
                requireMultipleApprovers={multipleApprovers}
            />
        );

    return (
        <div className="form-approve-section__container">
            {multipleApprovers && (
                <WarningMessage
                    className="form-approve-section__multi-approval-warning"
                    icon={IconTypes.UTROPSTEGN_24}
                    text={translated.needsAdditionalApproval}
                />
            )}

            <ButtonWithSpinner
                disabled={isApproveDisabled}
                className="transaction-form--submit"
                buttonType="positive"
                type="submit"
                showSpinner={paymentOperationPending}
                data-testid="payment-button"
            >
                <PaymentButtonText />
            </ButtonWithSpinner>
        </div>
    );
};

export default FormApproveSection;
